export const state = {
  // product: undefined,
  // products: []
  agregateur: {},
  agregateurs: [],
  pagination:''
}
